export enum EnvironmentType {
  DOCKER = 'DOCKER',
  K8S = 'K8S',
  EC2 = 'EC2',
}
